export default {
  // 设定cookies
  setCookie (name, value, expiredays) {
    const exp = new Date()
    exp.setTime(exp.getTime() + expiredays * 24 * 60 * 60 * 1000)
    document.cookie = name + '=' + encodeURI(value) + ';expires=' + exp.toGMTString()
  },

  // 读取cookies
  getCookie (name) {
    const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    const arr = document.cookie.match(reg)
    if (arr) {
      return (arr[2])
    } else {
      return null
    }
  },

  // 删除cookies
  delCookie (name) {
    const exp = new Date()
    exp.setTime(exp.getTime() - 1)
    const cval = this.getCookie(name)
    if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
}
